<template>
  <div :class="`agent-card_${agent.customHostname}`">
    <div class="box flex">
      <div class="box">
        <span class="item-name">
          <i
            class="color-block"
            :class="{
                    'online-color': agent.agentStatus === 'ONLINE' && agent.aggregatedRiskScore === 0,
                    'low-risk-color': agent.agentStatus === 'ONLINE' && agent.riskLevel.level === 'low',
                    'medium-risk-color': agent.agentStatus === 'ONLINE' && agent.riskLevel.level === 'medium',
                    'high-risk-color': agent.agentStatus === 'ONLINE' && agent.riskLevel.level === 'high',
                    'offline-color': agent.agentStatus === 'OFFLINE' || agent.agentStatus === 'DECOMMISSIONABLE'}"
          ></i>
          {{ agent.customHostname}}
        </span>
      </div>
      <div class="box grow flex reverse">
        <span class="small-bold-font">{{agent.aggregatedRiskScore}}</span>
      </div>
    </div>
    <div class="box flex">
      <div class="box" v-if="agent.system">
        <span class="small-font">Type: {{agent.system.kernel}} {{agent.system.platform}}</span>
      </div>
      <div class="box grow flex reverse">
        <!-- <span class="small-bold-font">XX iocs</span> -->
      </div>
    </div>
    <div class="box flex">
      <div class="box">
        <span class="small-font">
          Local IPs:
          <span v-for="(ip, idx) in agent.localIPs" :key="idx">
            {{ ip }}
            <el-divider v-if="idx !== agent.localIPs.length-1" direction="vertical"></el-divider>
          </span>
        </span>
      </div>
      <div class="box grow flex reverse">
        <!-- <span class="small-bold-font">{{agent.aggregatedRiskMomentum}}</span> -->
      </div>
    </div>
    <div class="box flex">
      <div class="box">
        <span class="small-font">Events consumed: {{$numeral(agent.eventsConsumed).format('0,0')}}</span>
      </div>
      <div class="box grow flex reverse"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AgentInfoCard",
  props: {
    agent: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style scoped>
@import "assets/styles/_variables.css";
@import "assets/styles/riskscore_colors.css";

.offline-color {
  border: 1px solid var(--offline-color);
}

.online-color {
  border: 1px solid var(--online-color);
}
</style>



// WEBPACK FOOTER //
// src/components/card/AgentInfoCard.vue